module.exports = __webpack_public_path__ + "img/badges.0f68a59a.png";